import MenuIcon from "@mui/icons-material/Menu";
import { Box, IconButton, Toolbar, Typography } from "@mui/material";
import { theme } from "~/utils";
import { StyleAppBar } from "./style";
import { useAuth } from "~/contexts";

type NavbarProps = {
  isDrawerOpen: boolean;
  toggleDrawer: () => void;
};

export const Navbar: React.FC<NavbarProps> = ({
  isDrawerOpen,
  toggleDrawer,
}) => {
  const { powerPlantName } = useAuth();

  return (
    <StyleAppBar
      position="fixed"
      open={isDrawerOpen}
      sx={{
        background: "white",
        boxShadow: "none",
        borderBottom: `1px solid ${theme.palette.grey["300"]}`,
      }}
    >
      <Toolbar>
        <IconButton
          edge="start"
          onClick={toggleDrawer}
          aria-label="open drawer"
          sx={{ marginRight: 5, color: "grey.400" }}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ flexGrow: 1 }} />
        {powerPlantName && (
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, color: "grey.700" }}
          >
            {powerPlantName}
          </Typography>
        )}
      </Toolbar>
    </StyleAppBar>
  );
};
